import { createStore } from 'vuex'
import createPersistedState from "vuex-persistedstate";
import ApiClient from '../js_utilities/apiClient';
import {parseISO} from 'date-fns'
import toastNotificationsModule   from './toastNotifications.js';
import {clearSessionTimers, startSessionTimers} from '@/js_utilities/sessionTimer.js'
import {refreshAccessToken} from '@/services/authService.js'


const apiClient = new ApiClient(process.env.VUE_APP_BASE_URL);

// TODO: find a way to use something like caseclasses to better define what a certain 
// elemt in the store represents
const workplacesModule = {
  state: () => ({ 
    absenceTypes: [
        {
            label: "Urlaub", value: "vacation"
        },
        {
            label: "Krankheit", value: "sickness"
        }
    ],
    absenceDurationOptions: [
        {
            label: "Ganzer Tag", value: "full", durationNum: 1.0              
        },
        {
            label: "Vormittag", value: "morning", durationNum: 0.5
        },
        {
            label: "Nachmittag", value: "afternoon", durationNum: 0.5
        }
    ],
    roleOptions: [{name: "base"}, {name: "admin"}],
    sexOptions: [{name: "m"}, {name: "w"}, {name: "d"}],
    employeeDateFields: ["dateOfBirth", "hireDate", "endOfContract", "shiftRhythmStartDate"],
    jwtToken: null,
    jwtRefreshToken: null,
    sessionExpiresAt: null,
    loggedInUser: null,
    userRole: null,
    teams: [],
    teamFunctions: [],
    departments: [],
    locations: [],
    sexes: [],
    qualifications: [],
    employees: [],
    deletedEmployees: [],
    shiftRhythms: [],
    availabilities: [],
    readNotifications: [],
    unreadNotifications: [],
    toastNotifications: []
  }),
    
  mutations: {
    updateEmployeeInEmployees(state, newEmployee) {
      // let employee = state.employees.find(emp => emp.uuid === newEmployee.uuid);
      const index = state.employees.findIndex(item => item.uuid === newEmployee.uuid);
      if (index !== -1) {
        state.employees[index] = newEmployee;
      }
      

    },
  
    updateLoggedInEmployee(state, employee) {
      state.loggedInUser = employee;
    },

    setJwtToken(state, token) {
      state.jwtToken = token;
      apiClient.setAuthToken(token);
    },

    setSessionExpiry(state, timestamp) {
      state.sessionExpiresAt = timestamp;
    },
    
    logoutUser(state) {
      state.jwtToken=null,
      state.jwtRefreshToken=null,
      state.sessionExpiresAt=null,
      state.loggedInUser=null,
      state.userRole=null,
      state.teams=[],
      state.sexes=[],
      state.teamFunctions=[],
      state.departments=[],
      state.locations=[],
      state.qualifications=[],
      state.employees=[],
      state.shiftRhythms=[],
      state.Availabilities=[],
      state.demandPlans={},
      state.demandPlansMetaData=[],
      state.readNotifications=[],
      state.unreadNotifications=[]
    },

    initialiseNotifications(state, payload) {
      // Use Vue.set or create new references to ensure deep reactivity
      // Handle notifications that may not have a request (e.g., info notifications)
      state.readNotifications = payload.read.map(notification => ({
        ...notification,
        request: notification.request ? {
          ...notification.request,
          messages: [...(notification.request.messages || [])]
        } : null
      }));

      state.unreadNotifications = payload.unread.map(notification => ({
        ...notification,
        request: notification.request ? {
          ...notification.request,
          messages: [...(notification.request.messages || [])]
        } : null
      }));
    },

    verifyUser(state, payload){
      console.log("verifyUser is called")
      state.jwtToken = payload.tokens.jwt_token
      state.jwtRefreshToken = payload.tokens.jwt_refresh_token

      state.loggedInUser = payload.user
      
      state.employeeDateFields.forEach((field) => {
        if (typeof state.loggedInUser[field] === 'string' || state.loggedInUser[field] instanceof String) {
          state.loggedInUser[field] = parseISO(state.loggedInUser[field], new Date())
        }
      })

      state.userRole = payload.user.role.name
    },

    // ------------ Shiftrhytms Types ---------------
    initialiseShiftRhythms(state, payload){
      state.shiftRhythms = payload
    },

    deleteShiftRhythm(state, id){
      state.shiftRhythms = state.shiftRhythms.filter(obj => obj.id != id )
    },

    // ------------ Employees ---------------
    initialiseEmployees(state, payload){      
      let filteredEmployees = payload.map((employee) => {
				state.employeeDateFields.forEach((field) => {
					if (typeof employee[field] === 'string' || employee[field] instanceof String) {
						employee[field] = parseISO(employee[field], new Date())
					}
				})
				return employee
			})
      state.employees = filteredEmployees
    },

    initialiseDeletedEmployees(state, payload){      
      let filteredEmployees = payload.map((employee) => {
				state.employeeDateFields.forEach((field) => {
					if (typeof employee[field] === 'string' || employee[field] instanceof String) {
						employee[field] = parseISO(employee[field], new Date())
					}
				})
				return employee
			})
      state.deletedEmployees = filteredEmployees
    },

    deleteEmployee(state, id){
      state.employees = state.employees.filter(obj => obj.uuid != id )
    },

    // ------------ Qualifications ---------------
    initialiseQualifications(state, payload) {
      state.qualifications = payload
    },

    addQualification(state, payload){
      state.qualifications.push(payload)
    },

    deleteQualification(state, id){
      state.qualifications = state.qualifications.filter(obj => obj.id != id )
    },

    // ------------ Teams ---------------
    initialiseTeams(state, payload) {
      state.teams = payload
    },

    initialiseSexes(state, payload) {
      state.sexes = payload
    },

    initialiseRoles(state, payload) {
      state.roleOptions = payload
    },


    addTeam(state, payload){
      state.teams.push(payload)
    },

    deleteTeam(state, id){
      state.teams = state.teams.filter(obj => obj.id != id )
    },


    // ------------ Team Functions ---------------
    initialiseTeamFunctions(state, payload) {
      state.teamFunctions = payload
    },

    addTeamFunction(state, payload){
      state.teamFunctions.push(payload)
    },

    deleteTeamFunction(state, id){
      state.teamFunctions = state.teamFunctions.filter(obj => obj.id != id )
    },

    // ------------ Department Functions ---------------
    initialiseDepartments(state, payload) {
      state.departments = payload
    },

    addDepartment(state, payload){
      state.departments.push(payload)
    },

    deleteDepartment(state, id){
      state.departments = state.departments.filter(obj => obj.id != id )
    },


    // ------------ Location Functions ---------------
    initialiseLocations(state, payload) {
      state.locations = payload
    },

    addLocation(state, payload){
      state.locations.push(payload)
    },

    deleteLocation(state, id){
      state.locations = state.locations.filter(obj => obj.id != id )
    },

  },


  getters: {
    getSexOptions(state){
      return state.sexes
    },
    getReadNotifications(state){
      return state.readNotifications
    },
    getUnreadNotifications(state){
      return state.unreadNotifications
    },

    getAbsenceTypes(state){
      return state.absenceTypes
    },

    getAbsenceDurationOptions(state){
      return state.absenceDurationOptions
    },

    getRoles(state) {
      return state.roleOptions
    },

    getTeams(state) {
      return state.teams;
    },
    getTeamFunctions(state) {
      return state.teamFunctions;
    }, 
    getDepartments(state) {
      return state.departments;
    }, 
    getLocations(state) {
      return state.locations;
    }, 

    getEmployees(state) {
      return state.employees
    },

    getDeletedEmployees(state) {
      return state.deletedEmployees
    },

    getEmployeeById: (state) => (id) => {
    // First search in active employees
    let employee = state.employees.find((obj) => obj.uuid === id);
    // If not found, search in deleted employees
    if (!employee) {
      employee = state.deletedEmployees.find((obj) => obj.uuid === id);
    }
    return employee;
  },
    getQualifications(state) {
      return state.qualifications;
    },
    getShiftRhythmNames(state){
      return Object.keys(state.shiftRhythms)
    },
    getAvailabilities(state){
      return state.Availabilities
    },
    getShiftRhythms(state){
      return state.shiftRhythms
    },
    getLoggedInUser(state){
      return state.loggedInUser
    },
    getJwtToken(state){
      return state.jwtToken
    },
    getJwtRefreshToken(state){
      return state.jwtRefreshToken
    },
    getIsAuthenticated(state){
      if (state.jwtToken !== null) {
        return true
      } else {
        return false
      }

    },
    getSessionExpiresAt(state) {
      return state.sessionExpiresAt
    }
  },
  actions: {

    logoutUser({ commit }) {
      // Perform any additional logout logic here, such as clearing local storage or making API requests.

      // Call the logout mutation to reset the store state.
      commit('logoutUser');

      clearSessionTimers()
      return "success"
    },

    async refreshUserToken({ commit, state }) {
      const refreshToken = state.jwtRefreshToken;
      if (!refreshToken) {
        throw new Error('No refresh token available');
      }

      const data = await refreshAccessToken(refreshToken);
      commit('setJwtToken', data.jwt_token);
      startSessionTimers(60 * 50, 60 * 60);

      return "success"
    },

    async verifyUser({commit}, payload){
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      };
  
      let url = process.env.VUE_APP_BASE_URL + "auth/login_user"

      const response = await fetch(url, requestOptions)

      if (response.ok) {
        let data = await response.json()
        apiClient.setAuthToken(data.tokens.jwt_token)
        commit('verifyUser', data)
        
        // console.log("apiClient.authToken")
        // console.log(apiClient.headers)
        

        return "success" 
      } else {
        // If status code is 401, throw a specific error message
        if(response.status === 401){
            throw new Error('Username or password is incorrect')
        } else {
            // For other errors, throw a generic error message
            throw new Error('Login failed')
        }
      }
    },

    // <------------------ Qualification API calls -------------------->
    async updateQualificationsFromDb({ commit }) {
      const data = await apiClient.getRequest("qualifications/")
      commit('initialiseQualifications', data)
      return "success"
    },

    async addQualification(_, payload) {
      await apiClient.postRequest("qualifications/", payload)
      return "success"  
    },

    async deleteQualification({commit}, id) {
      let endpoint = "qualifications/" + id
      await apiClient.deleteRequest(endpoint)
      commit('deleteQualification', id)
      return "success"  

    },


    // <------------------ SEX API calls -------------------->
    async updateSexesFromDb({ commit }) {
      const data = await apiClient.getRequest("sexes/")
      commit('initialiseSexes', data)
      return "success"
   
      // commit a mutation to set the data in the store
    
    },



    // <------------------ TEAM API calls -------------------->
    async updateTeamsFromDb({ commit }) {
      const data = await apiClient.getRequest("teams/")
      commit('initialiseTeams', data)
      return "success"
   
      // commit a mutation to set the data in the store
    
    },

    async addTeam(_, payload) {
      await apiClient.postRequest("teams/", payload)
      return "success"  
    },

    async deleteTeam({commit}, id) {
      let endpoint = "teams/" + id
      await apiClient.deleteRequest(endpoint)
      commit('deleteTeam', id)
      return "success"  

    },

    // <------------------ TEAMFUNCTIONS API calls -------------------->
    async updateTeamFunctionsFromDb({ commit }) {
      const data = await apiClient.getRequest("team_functions/")
      commit('initialiseTeamFunctions', data)
      return "success"

      // commit a mutation to set the data in the store
    
    },

    async addTeamFunction(_, payload) {
      await apiClient.postRequest("team_functions/", payload)
      return "success"  
    },

    async deleteTeamFunction({commit}, id) {
      let endpoint = "team_functions/" + id
      await apiClient.deleteRequest(endpoint)
      commit('deleteTeamFunction', id)
      return "success" 

    },

    // <------------------ DEPARTMENTS API calls -------------------->
    async updateDepartmentsFromDb({ commit }) {
      const data = await apiClient.getRequest("departments/")
      commit('initialiseDepartments', data)
      return "success"  
      // commit a mutation to set the data in the store
    },

    async addDepartment(_, payload) {
      await apiClient.postRequest("departments/", payload)
      return "success"  

    },

    async deleteDepartment({commit}, id) {
      let endpoint = "departments/" + id
      await apiClient.deleteRequest(endpoint)
      commit('deleteDepartment', id)
      return "success" 
    },

    // <------------------ LOCATIONS API calls --------------------> 
    async updateLocationsFromDb({ commit }) {
      const data = await apiClient.getRequest("locations/")
      commit('initialiseLocations', data)
      return "success"
    },

    async addLocation(_, payload) {      
      await apiClient.postRequest("locations/", payload)
      return "success"  
    },

    async deleteLocation({commit}, id) {
      let endpoint = "locations/" + id
      await apiClient.deleteRequest(endpoint)
      commit('deleteLocation', id)
      return "success" 

    },

    // <------------------ Employee API calls -------------------->

    async updateEmployeesFromDb({ commit }, { loadDeleted = false } = {}) {
      const endpoint = loadDeleted ? "employees/?load_deleted=true" : "employees/";
      const data = await apiClient.getRequest(endpoint)
      if (loadDeleted === false) {
        commit('initialiseEmployees', data)
      } else {
        commit('initialiseDeletedEmployees', data)
      }
    
      return "success"    
    },

    async updateEmployee(_, employee) {
      let endpoint = "employees/update/" + employee.uuid
      await apiClient.putRequest(endpoint, employee)
      return "success" 

    },

    async addEmployee(_, employee) { 
      // console.log("Employee in addEmployeeAction")
      // console.log(employee)
      let id = await apiClient.postRequest("employees/", employee)
      return id

    },

    async deleteEmployee({commit}, id) {
      let endpoint = "employees/" + id
      await apiClient.deleteRequest(endpoint)
      commit('deleteEmployee', id)
      return "success" 
    },

    // <------------------ SHIFTRHYTHM API calls -------------------->
    async addShiftRhythm(_, shiftRhythm) {
      await apiClient.postRequest("shift_rhythms/", shiftRhythm)
      return "success" 
    },


    async updateShiftRhythmsFromDb({commit}) {
      const data = await apiClient.getRequest("shift_rhythms/")
      commit('initialiseShiftRhythms', data)
      return "success"
    },

    async deleteShiftRhythm({commit}, id) {
      let endpoint = "shift_rhythms/" + id
      await apiClient.deleteRequest(endpoint)
      commit('deleteShiftRhythm', id)
      return "success" 
    },

    async updateShiftRhythm(_, payload){
      let endpoint = "shift_rhythms/update/" + payload["id"]
      // console.log("updateShiftRhythm")
      // console.log(payload)
      await apiClient.putRequest(endpoint, payload["data"])
      return "success" 
    },

    // <------------------ ROles API calls -------------------->
    async updateRolesFromDb({ commit }) {
      const data = await apiClient.getRequest("roles/")
      commit('initialiseRoles', data)
      return "success"
      // commit a mutation to set the data in the store
    },

    async updateNotificationsFromDb({ commit }, id) {
      let endpoint = "notifications/get_notifications_employee_id/" + id
      const data = await apiClient.getRequest(endpoint)
        
      commit('initialiseNotifications', data)
      return "success"
    },

  }
}



const store = createStore({
  modules: {
    workplaces: workplacesModule,
    toastNotifications: toastNotificationsModule
  },
  plugins: [createPersistedState()]
})

export default store;